'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuDrawer = function () {
  function MenuDrawer() {
    (0, _classCallCheck3.default)(this, MenuDrawer);

    this.navIcon = document.getElementById('js-menu');
    this.navContent = document.getElementById('js-nav');
    this.navWrapper = document.querySelector('.header__nav-mobile__wrapper');
    this.buttonClose = document.querySelector('[data-menuDrawer-close]');

    // menu & submenus
    this.menuMobileWrapper = document.querySelector('.header__nav-mobile__wrapper');
    this.subMenuWrapper = document.querySelector('.header__nav-mobile__submenus');
    this.allParents = document.querySelectorAll('[data-parent-item]');
    this.allChilds = document.querySelectorAll('[data-child-handle]');
    this.allButtonsClose = document.querySelectorAll('[data-back-submenu]');

    this.init();
  }

  (0, _createClass3.default)(MenuDrawer, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.close = this.close.bind(this);
      this.setBackdropVisible = window.theme.vuex._mutations.setBackdropVisible[0];

      this.onIconClick = this.onIconClick.bind(this);
      this.navIcon.addEventListener('click', this.onIconClick, false);
      this.buttonClose.addEventListener('click', this.onIconClick, false);

      this.setScrollHeight();
      this.onResize = this.onResize.bind(this);
      window.addEventListener('theme:resize', this.onResize);

      document.addEventListener('backdrop-clicked', function () {
        return _this.close();
      }, false);

      this.showSubmenu();
      this.backToPrimaryMenu();
    }
  }, {
    key: 'onIconClick',
    value: function onIconClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.setScrollHeight();
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.isOpen()) {
        this.close();
        this.setBackdropVisible(false);
      } else {
        this.open();
        this.setBackdropVisible(true);
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.navContent.classList.remove('is-active');
    }
  }, {
    key: 'open',
    value: function open() {
      this.navContent.classList.add('is-active');
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.navContent.classList.contains('is-active');
    }
  }, {
    key: 'setScrollHeight',
    value: function setScrollHeight() {
      var actionsHeight = document.querySelector('.header__nav-mobile__actions').offsetHeight;
      document.documentElement.style.setProperty('--menuMobileHeight', window.innerHeight - actionsHeight + 'px');
    }
  }, {
    key: 'showSubmenu',
    value: function showSubmenu() {
      var _this2 = this;

      if (this.allParents) {
        this.allParents.forEach(function (el) {
          el.addEventListener('click', function () {
            _this2.handle = el.getAttribute('data-parent-handle');

            _this2.childSubmenu = document.querySelector('[data-child-handle=' + _this2.handle + ']');
            _this2.menuMobileWrapper.classList.add('show-submenu');

            _this2.childSubmenu.classList.add('is-active');
          });
        });
      }
    }
  }, {
    key: 'backToPrimaryMenu',
    value: function backToPrimaryMenu() {
      var _this3 = this;

      if (this.allButtonsClose) {
        this.allButtonsClose.forEach(function (el) {
          el.addEventListener('click', function () {
            _this3.menuMobileWrapper.classList.remove('show-submenu');

            // eslint-disable-next-line
            setTimeout(function () {
              _this3.parentSubmenu = el.closest('[data-child-handle]');
              _this3.parentSubmenu.classList.remove('is-active');
            }, 500);
          });
        });
      }
    }
  }]);
  return MenuDrawer;
}();

new MenuDrawer();